import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage.jsx";
import BuatPengaduan from "./pages/BuatPengaduan.jsx";
import CekStatus from "./pages/CekStatus.jsx";
import LoginPage from "./pages/Loginpage.jsx";
import DashboardPage from "./pages/DashboardPage.jsx";

import "./App.css";

/* Guard: redirect ke /login jika belum login */
function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/buat-pengaduan" element={<BuatPengaduan />} />
        <Route path="/cek-status" element={<CekStatus />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
